export function createCheckoutPath(orderId, checkoutId) {
  return "/checkout/?order_id=".concat(orderId, "&checkout_id=").concat(checkoutId);
}